import type { ReactNode } from "react";
import { Box, SimpleGrid, Stack, Text } from "@mantine/core";

export interface Field {
  label: string;
  value: ReactNode;
  /** Span the full row width (for long values / nested blocks). */
  full?: boolean;
}

/** A labelled field with its value, humanized. */
export function FieldRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <Stack gap={2}>
      <Text size="xs" c="dimmed" tt="uppercase" fw={600} lts={0.4}>
        {label}
      </Text>
      <Box style={{ wordBreak: "break-word" }}>
        {typeof value === "string" || typeof value === "number" ? <Text>{value}</Text> : value}
      </Box>
    </Stack>
  );
}

/** Responsive two/three-column grid of labelled fields for a detail view. */
export function DetailGrid({ fields, cols = 3 }: { fields: Field[]; cols?: number }) {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: cols }} spacing="md" verticalSpacing="md">
      {fields.map((f, i) => (
        <Box key={i} style={f.full ? { gridColumn: "1 / -1" } : undefined}>
          <FieldRow label={f.label} value={f.value} />
        </Box>
      ))}
    </SimpleGrid>
  );
}
